<template lang="pug">
div
  .coupons-container(:style="color" :class="cardClass"
          v-if="!unOpenCouponGameAB && !['ladder-blend-choose','ladder-blend'].includes(cardClass)")
    expansionCss.expansion(v-if="isHaveExpanSion" :cardInfo="cardInfo")
    .coupon-money(v-else)
      .big-money {{cardInfo.cardMoney}}
      .money-sign {{cardInfo.cardSign}}
    .coupon-word {{cardInfo.couponWord}}
    .coupon-bussiness(:style="isnew?'color:#fff;margin-top:0.12rem':''") {{cardInfo.goodsPropDesc}}

  .coupons-container(:style="color" :class="cardClass"
          v-if="unOpenCouponGameAB && !['ladder-blend-choose','ladder-blend'].includes(cardClass)")
    .bus-desc {{cardInfo.goodsPropDesc}}
    .coupon-money
      .big-money {{cardInfo.amount}}
      .money-sign {{cardInfo.cardSign}}
    .coupon-word {{cardInfo.couponWord}}
    .coupon-bottom
      .have-expansive-btn(v-if="isHaveExpanSion" @click="openChangeModal(cardInfo)") 膨胀至{{expansiveValue(cardInfo)}}{{cardInfo.cardSign}}
        img.arror(src="https://m.hellobike.com/resource/gallery/61/oq4cU3MT_Frame%20(4).png?x-oss-process=image/quality,q_80")
      .text(v-if="!isHaveExpanSion") 开通后领取
    changeExpansionCardModalContainer(
    v-if="showChangeModal"
    :show.sync="showChangeModal"
    :openChangeType="3"
    :couponInfo="changeValue"
    :unOpenCouponGameAB="unOpenCouponGameAB"
  )
  .coupons-container(:style="color" :class="cardClass"
            v-if="['ladder-blend-choose','ladder-blend'].includes(cardClass)")
    .bus-desc {{cardInfo.goodsPropDesc}}
    .coupon-money
      .big-money {{cardInfo.amount}}
      .money-sign {{cardInfo.cardSign}}
    .coupon-word(v-if="cardClass === 'ladder-blend-choose'") {{(cardInfo.propType === 4
      ||cardInfo.propType===7)?`${cardInfo.propEffectiveDays}天可用`:cardInfo.subtitle}}
    .coupon-word(v-if="cardClass === 'ladder-blend'") {{cardInfo.couponWord}}
    .coupon-bottom(v-if="cardClass === 'ladder-blend'")
      .text {{`${cardInfo.ladderNum ?cardInfo.ladderNum+'单后领':'开通后领'}`}}
</template>
<script>
import expansionCss from './expansion-css.vue';
import changeExpansionCardModalContainer from './change-expansion-card-modal.vue';

export default {
  components: {
    expansionCss,
    changeExpansionCardModalContainer,
  },
  props: {
    isHaveExpanSion: {
      type: Boolean,
      default: false,
    },
    cardBackground: {
      type: String,
      default: '',
    },
    cardWidth: {
      type: String,
      default: '',
    },
    cardHeight: {
      type: String,
      default: '',
    },
    cardInfo: {
      type: Object,
      default: () => { },
    },
    expanSionBg: {
      type: String,
      default: '',
    },
    expanSionW: {
      type: String,
      default: '',
    },
    expanSionH: {
      type: String,
      default: '',
    },
    cardClass: {
      type: String,
      default: '',
    },
    unOpenCouponGameAB: {
      type: Boolean,
      default: false,
      required: false,
    },
    isnew: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showChangeModal: false,
    };
  },
  computed: {
    color() {
      if (this.unOpenCouponGameAB) {
        return `background-image: url(${this.expanSionBg}); width:${this.cardWidth};height:${this.cardHeight}`;
      }
      if (this.isHaveExpanSion) {
        return `background-image: url(${this.expanSionBg}); width:${this.expanSionW};height:${this.expanSionH}`;
      }
      if (this.cardBackground !== '') {
        return `background-image: url(${this.cardBackground}); width:${this.cardWidth};height:${this.cardHeight}`;
      }
      return ` width:${this.cardWidth};height:${this.cardHeight}`;
    },
    newStyleBottom() {
      if (this.isHaveExpanSion) {
        return { background: 'url(https://m.hellobike.com/resource/gallery/43/XRRHhhi1_Group%20611%20(1)%20(1).png)' };
      }
      return '';
    },
  },
  methods: {
    openChangeModal(expandItem) {
      this.changeValue = expandItem;
      this.showChangeModal = true;
    },
    expansiveValue(value) {
      if (value && value.vipExtendProperty) {
        if (value.vipExtendProperty.propType === 4 || value.vipExtendProperty.propType === 7) {
          return value.vipExtendProperty.propTimes;
        }
        return value.vipExtendProperty.propAmount;
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.coupons-container {
  background-size: 100% 100%;
  width: 0.76rem;
  height: 0.84rem;

  .expansion {
    margin-bottom: -0.05rem;
  }

  .coupon-money {
    display: flex;
    justify-content: center;
    margin-top: 0.03rem;
    padding-top: 0.05rem;

    .big-money {
      color: #f54311;
      font-family: "DIN Alternate Bold", sans-serif;
      font-size: 0.26rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-align: center;
    }

    .money-sign {
      color: #f54311;
      text-align: center;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-style: normal;
      font-weight: 500;
      margin-top: 0.1rem;
    }
  }

  .coupon-word {
    color: #7d3b2a;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.11rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    opacity: 0.7;
  }

  .coupon-bussiness {
    margin-top: 0.1rem;
    color: #7d3b2a;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.13rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .bus-desc {
    color: #7d3b2a;
    font-family: "PingFang SC", sans-serif;
    font-size: 0.12rem;
    line-height: 0.12rem;
    height: 0.12rem;
    text-align: center;
    white-space: nowrap;
  }
}
.ladder-two {
  background: linear-gradient(180deg, #FFFFFF 0%, #FFF8EB 100%);
  width: 0.59rem;
  height: 0.78rem;
  border-radius: 0.06rem;
  border: 0.005rem solid #FFCDBF;
  margin-top: -0.14rem;
  .coupon-money {
    height: 0.3rem;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 0;

    .big-money {
      margin-top: 0.03rem;
      font-size: 0.26rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-weight: bold;
      color: #f54311;
      line-height: 0.3rem;
    }

    .money-sign {
      margin-top: 0.12rem;
      font-size: 0.11rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #f54311;
      margin-left: 0.01rem;
    }
  }

  .coupon-word {
    text-align: center;
    font-size: 0.11rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #c5a399;
    line-height: 0.16rem;
    margin-top: 0.03rem;
  }


  .coupon-bussiness {
    text-align: center;
    font-size: 0.14rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    color: #fef8ea;
    line-height: 20px;
    margin-top: 0.06rem;
    font-weight: 500;
  }
}

.ladder_travle {
  width: 0.6rem;
  height: 0.79rem;
  background-size: 100% 100%;

  .coupon-money {
    height: 0.3rem;
    text-align: center;
    display: flex;
    justify-content: center;
    margin-top: 0;

    .big-money {
      margin-top: 0.03rem;
      font-size: 0.26rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-weight: bold;
      color: #f54311;
      line-height: 0.3rem;
    }

    .money-sign {
      margin-top: 0.12rem;
      font-size: 0.11rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #f54311;
      margin-left: 0.01rem;
    }
  }

  .coupon-word {
    text-align: center;
    font-size: 0.11rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #c5a399;
    line-height: 0.16rem;
    margin-top: 0.03rem;
  }


  .coupon-bussiness {
    text-align: center;
    font-size: 0.14rem;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    color: #fef8ea;
    line-height: 20px;
    margin-top: 0.06rem;
    font-weight: 500;
  }
}

.open-expand {
  min-height: 0.84rem;

  .coupon-money {
    height: 0.28rem;
  }

  .coupon-bottom {
    .button {
      margin: 0.08rem 0 0 0.08rem;
      width: 0.64rem;
      height: 0.2rem;
    }
    .have-expansive-btn {
      width:0.65rem;
      height: 0.2rem;
      margin: 0.08rem auto;
      font-family: PingFang HK;
      font-size: 0.11rem;
      font-weight: 600;
      line-height: 0.2rem;
      text-align: center;
      color: #fff;
      background: linear-gradient(180deg, #fa4614 0%, #ff6600 100%);
      border-radius: 0.5rem;
      position: relative;
      img.arror {
        position: absolute;
        top: 0;
        right: -0.07rem;
        width: 0.19rem;
        height: 0.2rem;
      }
    }

    .text {
      margin-top: 0.13rem;
      text-align: center;
      opacity: 0.5;
      color: #7d3b2a;
      font-family: "PingFang SC", sans-serif;
      font-weight: 600;
      font-size: 0.12rem;
      line-height: 0.12rem;
    }
  }
}

.ladder-blend {
  margin-right: 0.05rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom center;

  .bus-desc {
    height: 0.2rem;
    line-height: 0.12rem;
    color: #5a6066;
    padding-top: 0.08rem;
  }

  .coupon-money {
    padding-top: 0.01rem;
    height: 0.28rem;
  }

  .coupon-word {
    margin-top: 0.02rem;
  }

  .coupon-bottom {
    margin-top: 0.13rem;

    .text {
      color: #fff;
      font-family: "PingFang SC", sans-serif;
      font-weight: 500;
      font-size: 0.12rem;
      text-align: center;
    }
  }

  &.locked {
    .coupon-word {
      color: #879099;
      opacity: 0.7;
    }
  }
}

.ladder-blend-choose {
  .bus-desc {
    color: #7d3b2a;
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 0.162rem;
    line-height: 0.1679rem;
    height: 0.1679rem;
    padding-top: 0.011rem;
  }

  .coupon-money {
    margin-top: 0.1245rem;

    .big-money {
      font-weight: 700;
      font-size: 0.36rem;
    }

    .money-sign {
      font-weight: 500;
      font-size: 0.15rem;
      margin-top: 0.12rem;
    }
  }

  .coupon-word {
    margin-top: 0.18rem;
    height: 0.206rem;
    line-height: 0.206rem;
    opacity: 0.7;
    color: #7d3b2a;
    font-family: "PingFang SC", sans-serif;
    font-size: 0.15rem;
  }
}
</style>
